import { takeEvery, put, all, call } from 'redux-saga/effects';
import * as types from './launchpadUserActionTypes';
import * as actions from './launchpadUserActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';
import * as alert from '../alert/alertActions';

// function* getLaunchpadUserSaga(action) {
//   try {
    
//     const { data } = yield call(endpoints.getLaunchpadUsers);
//     console.log(data)
//     yield put(actions.getLaunchpadUsersActionData(data));
//     // yield put (projectActions.getProjectByIDData(data))
//   } catch (e) {
//     console.log(e)
//     yield put(actions.getLaunchpadUsersActionError(e));
//   }
// }


function* getLaunchpadUserSaga(action) {
  try {
    const { data } = yield call(endpoints.getLaunchpadUsers);
    yield put(actions.getLaunchpadUsersActionData(data));
  } catch (e) {
    errorHandler(e)
    yield put(actions.getLaunchpadUsersActionError(e));
  }
}

function* updateLaunchpadUserSaga(action) {
  try {
    const { userID, body } = action.payload;
    const { data } = yield call(endpoints.updateLaunchpadUser, userID, body);
    const refreshedUsersResponse = yield call(endpoints.getLaunchpadUsers);

    yield put(actions.updateLaunchpadUserActionData(data));
    yield put(actions.getLaunchpadUsersActionData(refreshedUsersResponse.data));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e);
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message || e?.response?.data?.detail,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.updateLaunchpadUserActionError(e));
  }
}

function* resendLaunchpadActivationEmailSaga(action) {
  try {
    const { userID } = action.payload;
    const { data } = yield call(endpoints.resendLaunchpadActivationEmail, userID);

    yield put(actions.resendLaunchpadActivationEmailActionData(data));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e);
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message || e?.response?.data?.detail,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.resendLaunchpadActivationEmailActionError(e));
  }
}

function* watchGetLaunchpadUser() {
  yield takeEvery(types.GET_LAUNCHPADUSERS_REQUEST, getLaunchpadUserSaga);
}

function* watchUpdateLaunchpadUser() {
  yield takeEvery(types.UPDATE_LAUNCHPADUSER_REQUEST, updateLaunchpadUserSaga);
}

function* watchResendLaunchpadActivationEmail() {
  yield takeEvery(
    types.RESEND_LAUNCHPADUSER_ACTIVATION_EMAIL_REQUEST,
    resendLaunchpadActivationEmailSaga
  );
}


export function* launchpadUserSaga() {
  yield all([
    watchGetLaunchpadUser(),
    watchUpdateLaunchpadUser(),
    watchResendLaunchpadActivationEmail(),
  ]);
}
